module.exports = __webpack_public_path__ + "img/logo_rectangular.a0eff0fb.svg";